'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _components = require('../../../components');
var _OMAdvancedFiltersCheckbox = require('./OMAdvancedFiltersCheckbox.scss');var _OMAdvancedFiltersCheckbox2 = _interopRequireDefault(_OMAdvancedFiltersCheckbox);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var OMAdvancedFiltersCheckbox = function OMAdvancedFiltersCheckbox(_ref) {var name = _ref.name,label = _ref.label,value = _ref.value,isMobile = _ref.isMobile,_onChange = _ref.onChange;return (
    _react2.default.createElement('label', { htmlFor: name, className: _OMAdvancedFiltersCheckbox2.default.wrapper },
      _react2.default.createElement(_components.OMFiltersTitle, { icon: name, label: label, isMobile: isMobile }),

      _react2.default.createElement('span', { className: _OMAdvancedFiltersCheckbox2.default.advancedCheckbox },
        _react2.default.createElement('input', {
          id: name,
          type: 'checkbox',
          value: value,
          checked: value,
          onChange: function onChange() {return _onChange(name, !value);} }),


        _react2.default.createElement('span', null))));};




OMAdvancedFiltersCheckbox.propTypes = {
  name: _propTypes2.default.string,
  label: _propTypes2.default.string,
  value: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  onChange: _propTypes2.default.func };exports.default =


OMAdvancedFiltersCheckbox;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMAdvancedFiltersCheckbox/OMAdvancedFiltersCheckbox.js
// module id = 2728
// module chunks = 0